import React, { Component } from 'react';
import { Modal, Row, Col, Container, Table } from 'react-bootstrap';


class AttendanceReportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {

    console.log("llllllllllllllllll", this.props)

    let roomWiseData = this.props.stateData.roomWiseData;

    let data = [];

    let uniqueStudents = [...new Set(roomWiseData?.map((item) => item.edu_student_id))];

    console.log("uniqueStudents", uniqueStudents, roomWiseData);


    uniqueStudents.map((item) => {
      let studentName = this.props.getNewEducationalStudents.find((item1) => item1.student_id == item);
      let presentData = roomWiseData.filter((item2) => item2.edu_student_id == item).filter((item3) => item3.attendance_status == 1 && item3.attended_date != null).length
      let dateWiseAttendance = [];



      this.props.stateData.dateArrayfinal.map((date) => {
        let eachDateWise = roomWiseData.filter((item2) => item2.edu_student_id == item).filter((item3) => item3.attended_date == date.unixDate);
        console.log("eachDateWise", eachDateWise);
        if (eachDateWise.length > 0) {
          if (eachDateWise[0].attendance_status == 0) {
            dateWiseAttendance.push("A")
          } else {
            dateWiseAttendance.push("P")
          }

        } else {
          dateWiseAttendance.push("-")
        }

      })
      data.push({ studentName: studentName.student_name, totalPresent: `${presentData} / ${this.props.stateData.dateArrayfinal.length}`, dateWiseAttendance: dateWiseAttendance })
    })


    console.log("data", data);




    return (
      <Modal {...this.props}
        size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title>Room Wise Data</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Container className='table_data'>
            <Row className='align_center'>
              <Col xl={12} lg={12} md={12} >
                {
                  this.props.stateData.loader == 1 ?
                    (
                      <Container>
                        <Row>
                          <Col sm={12}>
                            <div className="spinner-border text-primary text-center loading-img-center"></div>
                          </Col>
                        </Row>
                      </Container>
                    )
                    :
                    (
                      <Table className="table  table-bordered table-hover ">
                        <thead style={{ backgroundColor: "#191970", color: "white" }}>
                          <tr>
                            <th rowSpan="2">Sno</th>
                            <th rowSpan="2">Student Name</th>
                            <th rowSpan="2">Total Present</th>
                            <th colSpan={this.props.stateData.dateArrayfinal.length}>Date</th>
                          </tr>
                          <tr>
                            {
                              this.props.stateData.dateArrayfinal.map((item => {
                                return (<th>{item.date}</th>)
                              }))
                            }
                          </tr>
                        </thead>

                        {
                          data.length > 0 ? (
                            <tbody>
                              {

                                data.map((item, index) => {
                                  return (
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{item.studentName}</td>
                                      <td>{item.totalPresent}</td>
                                      {
                                        item.dateWiseAttendance.map((item3) => {
                                          return (
                                            <td>{item3}</td>
                                          )

                                        })
                                      }
                                    </tr>
                                  )
                                })
                              }
                            </tbody>
                          ) : (
                            <Row>
                              <Col xs={12} md={12} sm={12} className="d-flex align-items-center justify-content-md-center">
                                <h4 className='mt-3 text-center'><span className="text-danger"> * </span>  No data available</h4>
                              </Col>
                            </Row>

                          )
                        }

                      </Table>
                    )
                }
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer variant="white" className="px-4">
        </Modal.Footer>
      </Modal >
    )
  }
}

export default AttendanceReportModal;
